import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import billingService from '../../services/billingService';
import printerService from '../../services/printerService';
import SaldoClienteModal from './SaldoClienteModal';

const Clientes = () => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [submitting, setSubmitting] = useState(false);
    
    // Modal de Creación
    const [showModal, setShowModal] = useState(false);
    const [newCustomer, setNewCustomer] = useState({
        email: '',
        password: 'Password123!',
        password_confirmation: 'Password123!',
        first_name: '',
        last_name: '',
        cedula: '',
        phone: '',
        address: '',
        city: 'Tulcán'
    });

    // Modal de Edición
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingCustomer, setEditingCustomer] = useState(null);

    // Modal de Cobro de Fiados / Cuentas por Cobrar
    const [showCobrarModal, setShowCobrarModal] = useState(false);
    const [debtCustomer, setDebtCustomer] = useState(null);
    const [customerDebts, setCustomerDebts] = useState(null);
    const [loadingDebts, setLoadingDebts] = useState(false);
    const [cobrarAmount, setCobrarAmount] = useState('');
    const [cobrarMethod, setCobrarMethod] = useState('efectivo');
    const [cobrarReference, setCobrarReference] = useState('');
    const [cobrarNotes, setCobrarNotes] = useState('');
    const [processingCobro, setProcessingCobro] = useState(false);

    // Modal de Abono / Saldo a favor
    const [saldoCustomer, setSaldoCustomer] = useState(null);

    // Modal de Ticket / Voucher
    const [previewCustomer, setPreviewCustomer] = useState(null);
    const [voucherConfig, setVoucherConfig] = useState({
        business_name: 'SOPHIA´S COFFE',
        ruc: '0401788617001',
        establishment_address: 'Av. Principal 123, Tulcán - Ecuador',
        obligation_contable: 'NO',
        contribuyente_regimen: 'RIMPE - NEGOCIO POPULAR',
        footer_message: '¡Gracias por su preferencia!\nEste documento es una representación impresa de un Comprobante Electrónico (RIDE).'
    });

    useEffect(() => {
        fetchCustomers();
        loadVoucherConfig();
    }, []);

    const loadVoucherConfig = async () => {
        try {
            const data = await billingService.getConfig();
            if (data) {
                setVoucherConfig({
                    business_name: data.business_name || 'SOPHIA´S COFFE',
                    ruc: data.ruc || '0401788617001',
                    establishment_address: data.establishment_address || 'Av. Principal 123, Tulcán - Ecuador',
                    obligation_contable: data.obligation_contable || 'NO',
                    contribuyente_regimen: data.contribuyente_regimen || 'RIMPE - NEGOCIO POPULAR',
                    footer_message: data.footer_message || '¡Gracias por su preferencia!\nEste documento es una representación impresa de un Comprobante Electrónico (RIDE).'
                });
            }
        } catch (e) {
            console.error('Error cargando configuración de ticket:', e);
        }
    };

    const fetchCustomers = async (search = '') => {
        setLoading(true);
        setError('');
        try {
            const params = search ? { search } : {};
            const response = await api.get('/api/customers/admin/list/', {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE,
                params
            });
            setCustomers(response.data.data.customers || []);
        } catch (err) {
            console.error('Error fetching customers:', err);
            setError('Error al cargar clientes: ' + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        fetchCustomers(searchTerm);
    };

    // ========== CREAR CLIENTE ==========
    const handleCreateCustomer = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post('/api/customers/register/', newCustomer, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });

            alert('Cliente creado exitosamente');
            closeModal();
            fetchCustomers();
        } catch (err) {
            console.error('Error creating customer:', err);
            const errorData = err.response?.data;
            let errorMessage = 'Error al crear cliente';

            if (errorData?.errors) {
                errorMessage += ':\n' + Object.entries(errorData.errors)
                    .map(([key, val]) => `- ${key}: ${val}`)
                    .join('\n');
            } else if (errorData?.message) {
                errorMessage += ': ' + errorData.message;
            } else {
                errorMessage += ': ' + err.message;
            }

            alert(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setNewCustomer({
            email: '',
            password: 'Password123!',
            password_confirmation: 'Password123!',
            first_name: '',
            last_name: '',
            cedula: '',
            phone: '',
            address: '',
            city: 'Tulcán'
        });
    };

    // ========== EDITAR CLIENTE ==========
    const handleOpenEdit = (customer) => {
        setEditingCustomer({
            id: customer.id,
            first_name: customer.first_name || '',
            last_name: customer.last_name || '',
            cedula: customer.cedula || customer.dni || '',
            email: customer.email || '',
            phone: customer.phone || '',
            address: customer.address || '',
            city: customer.city || 'Tulcán',
            customer_type: customer.customer_type || 'regular'
        });
        setShowEditModal(true);
    };

    const handleUpdateCustomer = async (e) => {
        e.preventDefault();
        if (!editingCustomer) return;
        setSubmitting(true);
        try {
            await api.put(`/api/customers/admin/${editingCustomer.id}/`, editingCustomer, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });

            alert('Cliente actualizado exitosamente');
            setShowEditModal(false);
            setEditingCustomer(null);
            fetchCustomers(searchTerm);
        } catch (err) {
            console.error('Error updating customer:', err);
            alert('Error al actualizar: ' + (err.response?.data?.message || err.message));
        } finally {
            setSubmitting(false);
        }
    };

    // ========== ELIMINAR CLIENTE ==========
    const handleDeleteCustomer = async (customer) => {
        const customerName = `${customer.first_name} ${customer.last_name}`.trim();
        const confirmDelete = window.confirm(
            `¿Estás seguro de que deseas eliminar o desactivar al cliente "${customerName}"?\n\nSi posee órdenes o deudas pendientes, se desactivará de forma segura.`
        );
        if (!confirmDelete) return;

        try {
            await api.delete(`/api/customers/admin/${customer.id}/`, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            alert('Cliente procesado exitosamente.');
            fetchCustomers(searchTerm);
        } catch (err) {
            console.error('Error deleting customer:', err);
            alert('Error al eliminar cliente: ' + (err.response?.data?.message || err.message));
        }
    };

    // ========== COBRAR FIADO / CUENTAS POR COBRAR ==========
    const handleOpenCobrar = async (customer) => {
        setDebtCustomer(customer);
        setShowCobrarModal(true);
        setLoadingDebts(true);
        setCustomerDebts(null);
        setCobrarAmount('');
        setCobrarReference('');
        setCobrarNotes('');
        setCobrarMethod('efectivo');

        try {
            const res = await api.get(`/api/customers/admin/${customer.id}/debts/`, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });
            const data = res.data.data;
            setCustomerDebts(data);
            // El monto empieza vacío: si viniera con la deuda escrita, al teclear un abono
            // (ej. '10') quedaría '30.0010' y se cobraría todo. Para cobrar todo está 'Pagar Todo'.
            setCobrarAmount('');
        } catch (err) {
            console.error('Error fetching customer debts:', err);
            alert('Error al consultar deudas: ' + (err.response?.data?.message || err.message));
        } finally {
            setLoadingDebts(false);
        }
    };

    const handleSubmitCobro = async (e) => {
        e.preventDefault();
        if (!debtCustomer) return;
        const amountNum = Math.round(parseFloat(cobrarAmount) * 100) / 100;
        if (isNaN(amountNum) || amountNum <= 0) {
            alert('Por favor ingresa un monto válido a cobrar.');
            return;
        }
        const totalDebt = customerDebts?.total_debt || 0;
        if (amountNum > totalDebt + 0.009) {
            alert(`El monto ($${amountNum.toFixed(2)}) es mayor a lo que debe ($${totalDebt.toFixed(2)}).`);
            return;
        }
        const remainingAfter = Math.max(0, totalDebt - amountNum);
        const confirmMessage = remainingAfter > 0.009
            ? `Registrar ABONO de $${amountNum.toFixed(2)}.\nQuedará debiendo $${remainingAfter.toFixed(2)}.\n\n¿Continuar?`
            : `Registrar PAGO TOTAL de $${amountNum.toFixed(2)}.\nLa deuda quedará en $0.00.\n\n¿Continuar?`;
        if (!window.confirm(confirmMessage)) return;

        setProcessingCobro(true);
        try {
            const res = await api.post(`/api/customers/admin/${debtCustomer.id}/pay-debt/`, {
                amount: amountNum,
                payment_method: cobrarMethod,
                payment_reference: cobrarReference,
                notes: cobrarNotes
            }, {
                baseURL: process.env.REACT_APP_FAST_FOOD_SERVICE
            });

            const remaining = res.data?.data?.remaining_debt ?? remainingAfter;
            alert(`Cobro registrado con éxito: $${amountNum.toFixed(2)} USD de ${debtCustomer.first_name} ${debtCustomer.last_name}.\n` +
                (remaining > 0.009 ? `Saldo pendiente: $${remaining.toFixed(2)} USD.` : 'La deuda quedó saldada.'));
            setShowCobrarModal(false);
            setDebtCustomer(null);
            fetchCustomers(searchTerm);
        } catch (err) {
            console.error('Error paying debt:', err);
            alert('Error al procesar cobro: ' + (err.response?.data?.message || err.message));
        } finally {
            setProcessingCobro(false);
        }
    };

    const formatCurrency = (amount) => {
        const num = parseFloat(amount) || 0;
        return `$${num.toFixed(2)} USD`;
    };

    if (loading && customers.length === 0) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: 'var(--sidebar-bg)' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        display: 'inline-block',
                        width: '48px',
                        height: '48px',
                        border: '4px solid #e5e7eb',
                        borderTopColor: 'var(--primary-color, #4a1f0c)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    <p style={{ marginTop: '16px', color: '#4b5563', fontWeight: '500' }}>Cargando clientes y saldos...</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom right, var(--sidebar-bg), var(--sidebar-bg))', padding: '1.25rem 1rem' }}>
            <div style={{ maxWidth: '1380px', margin: '0 auto', width: '100%' }}>
                {/* Header */}
                <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                    <div>
                        <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: 'var(--primary-color, #4a1f0c)', marginBottom: '4px' }}>
                            <i className="bi bi-people-fill" style={{ marginRight: '8px' }}></i>Gestión de Clientes y Cuentas por Cobrar (Fiados)
                        </h1>
                        <p style={{ color: '#6b7280', margin: 0 }}>
                            Administra clientes, consulta saldos deudores de fiados, registra abonos y gestiona la base de datos.
                        </p>
                    </div>
                    <button
                        onClick={() => setShowModal(true)}
                        style={{
                            backgroundColor: 'var(--primary-color, #4a1f0c)',
                            color: 'white',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            border: 'none',
                            fontWeight: '600',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.2s',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                    >
                        <i className="bi bi-person-plus-fill" style={{ fontSize: '18px' }}></i>
                        Nuevo Cliente
                    </button>
                </div>

                {/* Search Bar */}
                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', padding: '16px', marginBottom: '24px' }}>
                    <form onSubmit={handleSearch} style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div style={{ flex: 1, position: 'relative' }}>
                            <i className="bi bi-search" style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', fontSize: '16px' }}></i>
                            <input
                                type="text"
                                placeholder="Buscar por nombre, apellido, cédula/RUC, email o teléfono..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px 10px 44px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    fontSize: '14px',
                                    transition: 'all 0.2s'
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                backgroundColor: 'var(--primary-color, #4a1f0c)',
                                color: 'white',
                                padding: '10px 22px',
                                borderRadius: '8px',
                                border: 'none',
                                fontWeight: '600',
                                cursor: 'pointer',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            <i className="bi bi-search"></i> Buscar
                        </button>
                        {searchTerm && (
                            <button
                                type="button"
                                onClick={() => { setSearchTerm(''); fetchCustomers(''); }}
                                style={{
                                    backgroundColor: '#f3f4f6',
                                    color: '#4b5563',
                                    padding: '10px 16px',
                                    borderRadius: '8px',
                                    border: '1px solid #d1d5db',
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                Limpiar
                            </button>
                        )}
                    </form>
                </div>

                {/* Error Message */}
                {error && (
                    <div style={{
                        backgroundColor: '#fef2f2',
                        border: '1px solid #fecaca',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        marginBottom: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#991b1b',
                        fontSize: '14px'
                    }}>
                        <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '18px' }}></i>
                        <span>{error}</span>
                    </div>
                )}

                {/* Customers Table */}
                <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                <tr>
                                    <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Cliente
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Cédula / RUC
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Contacto
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Saldo Fiados (Deuda)
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Abono (Saldo a Favor)
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Total Pedidos
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Registro
                                    </th>
                                    <th style={{ padding: '16px 20px', textAlign: 'center', fontSize: '11px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                        Acciones
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {customers.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" style={{ padding: '48px 24px', textAlign: 'center' }}>
                                            <i className="bi bi-people" style={{ fontSize: '48px', color: '#d1d5db', display: 'block', marginBottom: '12px' }}></i>
                                            <p style={{ color: '#6b7280', fontWeight: '500', fontSize: '16px', margin: 0 }}>
                                                {searchTerm ? 'No se encontraron clientes para esta búsqueda' : 'No hay clientes registrados'}
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    customers.map(customer => {
                                        const pendingDebt = parseFloat(customer.pending_debt) || 0;
                                        const hasDebt = pendingDebt > 0;
                                        const balance = parseFloat(customer.balance) || 0;

                                        return (
                                            <tr
                                                key={customer.id}
                                                style={{
                                                    borderBottom: '1px solid #e5e7eb',
                                                    transition: 'background-color 0.2s',
                                                    backgroundColor: hasDebt ? '#fffbeb' : 'white'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = hasDebt ? '#fef3c7' : '#f8fafc'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = hasDebt ? '#fffbeb' : 'white'}
                                            >
                                                {/* Cliente */}
                                                <td style={{ padding: '14px 20px' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                        <div style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            borderRadius: '50%',
                                                            backgroundColor: hasDebt ? '#fed7aa' : 'var(--primary-light, #f5ebe4)',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: '700',
                                                            color: hasDebt ? '#c2410c' : 'var(--primary-color, #4a1f0c)',
                                                            fontSize: '14px'
                                                        }}>
                                                            {customer.first_name?.charAt(0)}{customer.last_name?.charAt(0)}
                                                        </div>
                                                        <div>
                                                            <p style={{ margin: 0, fontWeight: '700', color: '#1e293b', fontSize: '14px' }}>
                                                                {customer.first_name} {customer.last_name}
                                                            </p>
                                                            <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#64748b' }}>
                                                                {customer.email || 'Sin correo'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Cédula */}
                                                <td style={{ padding: '14px 20px', whiteSpace: 'nowrap' }}>
                                                    <span style={{ fontFamily: 'monospace', fontWeight: '700', color: '#334155', fontSize: '13px', background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px' }}>
                                                        {customer.cedula || customer.dni || customer.identification || customer.tax_id || '9999999999999'}
                                                    </span>
                                                </td>

                                                {/* Contacto */}
                                                <td style={{ padding: '14px 20px', whiteSpace: 'nowrap' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <i className="bi bi-telephone-fill" style={{ color: '#64748b', fontSize: '13px' }}></i>
                                                        <span style={{ color: '#334155', fontSize: '13px', fontWeight: '500' }}>
                                                            {customer.phone || 'Sin teléfono'}
                                                        </span>
                                                    </div>
                                                </td>

                                                {/* Saldo Fiado / Deuda */}
                                                <td style={{ padding: '14px 20px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    {hasDebt ? (
                                                        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                                                            <span style={{
                                                                backgroundColor: '#fee2e2',
                                                                color: '#b91c1c',
                                                                border: '1px solid #fca5a5',
                                                                padding: '4px 10px',
                                                                borderRadius: '20px',
                                                                fontSize: '13px',
                                                                fontWeight: '800'
                                                            }}>
                                                                ${pendingDebt.toFixed(2)} USD
                                                            </span>
                                                            <span style={{ fontSize: '11px', color: '#b91c1c', fontWeight: '600' }}>
                                                                Debe Fiado
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <span style={{
                                                            backgroundColor: '#dcfce7',
                                                            color: '#15803d',
                                                            border: '1px solid #86efac',
                                                            padding: '4px 10px',
                                                            borderRadius: '20px',
                                                            fontSize: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            <i className="bi bi-check-circle-fill" style={{ marginRight: '4px' }}></i>$0.00 Al día
                                                        </span>
                                                    )}
                                                </td>

                                                {/* Abono / Saldo a favor */}
                                                <td style={{ padding: '14px 20px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => setSaldoCustomer(customer)}
                                                        title="Ver abonos y consumos del cliente"
                                                        style={{
                                                            backgroundColor: balance > 0 ? '#ede9fe' : '#f8fafc',
                                                            color: balance > 0 ? '#6d28d9' : '#94a3b8',
                                                            border: `1px solid ${balance > 0 ? '#ddd6fe' : '#e2e8f0'}`,
                                                            padding: '4px 10px',
                                                            borderRadius: '20px',
                                                            fontSize: '13px',
                                                            fontWeight: balance > 0 ? '800' : '600',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <i className="bi bi-wallet2" style={{ marginRight: '4px' }}></i>
                                                        ${balance.toFixed(2)} USD
                                                    </button>
                                                </td>

                                                {/* Total Pedidos */}
                                                <td style={{ padding: '14px 20px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b' }}>
                                                        {customer.total_orders || 0} pedido{(customer.total_orders || 0) !== 1 ? 's' : ''}
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: '#64748b' }}>
                                                        {formatCurrency(customer.total_spent || 0)}
                                                    </div>
                                                </td>

                                                {/* Registro */}
                                                <td style={{ padding: '14px 20px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    <span style={{ fontSize: '12px', color: '#64748b' }}>
                                                        {customer.created_at ? new Date(customer.created_at).toLocaleDateString('es-EC', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        }) : '-'}
                                                    </span>
                                                </td>

                                                {/* Acciones */}
                                                <td style={{ padding: '14px 20px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                        {/* Botón Cobrar Fiado */}
                                                        <button
                                                            type="button"
                                                            title={hasDebt ? `Cobrar fiado pendiente de $${pendingDebt.toFixed(2)}` : 'Ver historial de fiados o registrar cobro'}
                                                            onClick={() => handleOpenCobrar(customer)}
                                                            style={{
                                                                padding: '6px 12px',
                                                                backgroundColor: hasDebt ? '#16a34a' : '#f1f5f9',
                                                                color: hasDebt ? '#ffffff' : '#334155',
                                                                border: `1px solid ${hasDebt ? '#15803d' : '#cbd5e1'}`,
                                                                borderRadius: '6px',
                                                                fontSize: '12px',
                                                                fontWeight: '700',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '5px',
                                                                boxShadow: hasDebt ? '0 2px 4px rgba(22, 163, 74, 0.2)' : 'none',
                                                                transition: 'all 0.2s'
                                                            }}
                                                        >
                                                            <i className="bi bi-cash-coin" style={{ fontSize: '14px' }}></i>
                                                            {hasDebt ? 'Cobrar Fiado' : 'Cobrar'}
                                                        </button>

                                                        {/* Botón Abono / Saldo a favor */}
                                                        <button
                                                            type="button"
                                                            title="Registrar abono (pago adelantado) y ver su historial"
                                                            onClick={() => setSaldoCustomer(customer)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                backgroundColor: '#f5f3ff',
                                                                color: '#6d28d9',
                                                                border: '1px solid #ddd6fe',
                                                                borderRadius: '6px',
                                                                fontSize: '12px',
                                                                fontWeight: '700',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}
                                                        >
                                                            <i className="bi bi-wallet2"></i> Abono
                                                        </button>

                                                        {/* Botón Editar */}
                                                        <button
                                                            type="button"
                                                            title="Editar información del cliente"
                                                            onClick={() => handleOpenEdit(customer)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                backgroundColor: '#f8fafc',
                                                                color: '#0284c7',
                                                                border: '1px solid #bae6fd',
                                                                borderRadius: '6px',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}
                                                        >
                                                            <i className="bi bi-pencil-square"></i> Editar
                                                        </button>

                                                        {/* Botón Eliminar */}
                                                        <button
                                                            type="button"
                                                            title="Eliminar o desactivar cliente"
                                                            onClick={() => handleDeleteCustomer(customer)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                backgroundColor: '#fff1f2',
                                                                color: '#e11d48',
                                                                border: '1px solid #fecdd3',
                                                                borderRadius: '6px',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}
                                                        >
                                                            <i className="bi bi-trash-fill"></i>
                                                        </button>

                                                        {/* Botón Ticket SRI */}
                                                        <button
                                                            type="button"
                                                            title="Ver comprobante de factura"
                                                            onClick={() => setPreviewCustomer(customer)}
                                                            style={{
                                                                padding: '6px 10px',
                                                                backgroundColor: '#f1f5f9',
                                                                color: '#475569',
                                                                border: '1px solid #cbd5e1',
                                                                borderRadius: '6px',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                cursor: 'pointer',
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}
                                                        >
                                                            <i className="bi bi-receipt"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Stats */}
                {customers.length > 0 && (
                    <div style={{ marginTop: '20px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
                        <p style={{ fontSize: '14px', color: '#4b5563', margin: 0 }}>
                            Mostrando <span style={{ fontWeight: '700', color: '#1f2937' }}>{customers.length}</span> cliente{customers.length !== 1 ? 's' : ''}
                        </p>
                        <div style={{ display: 'flex', gap: '16px', fontSize: '13px' }}>
                            <span style={{ color: '#b91c1c', fontWeight: '700' }}>
                                <i className="bi bi-exclamation-circle-fill" style={{ marginRight: '4px' }}></i>
                                Clientes con Fiado: {customers.filter(c => parseFloat(c.pending_debt) > 0).length}
                            </span>
                            <span style={{ color: '#15803d', fontWeight: '700' }}>
                                <i className="bi bi-check-circle-fill" style={{ marginRight: '4px' }}></i>
                                Clientes al día: {customers.filter(c => !c.pending_debt || parseFloat(c.pending_debt) <= 0).length}
                            </span>
                            <span style={{ color: '#6d28d9', fontWeight: '700' }}>
                                <i className="bi bi-wallet2" style={{ marginRight: '4px' }}></i>
                                Clientes con abono: {customers.filter(c => parseFloat(c.balance) > 0).length}
                            </span>
                        </div>
                    </div>
                )}
            </div>

            {/* MODAL DE ABONO / SALDO A FAVOR */}
            {saldoCustomer && (
                <SaldoClienteModal
                    customer={saldoCustomer}
                    onClose={() => setSaldoCustomer(null)}
                    onChanged={() => fetchCustomers(searchTerm)}
                />
            )}

            {/* ==================================================================== */}
            {/* MODAL DE COBRO DE FIADOS (CUENTAS POR COBRAR / ABONOS) */}
            {/* ==================================================================== */}
            {showCobrarModal && debtCustomer && (
                <div
                    onClick={() => setShowCobrarModal(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1100,
                        padding: '16px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '650px',
                            width: '100%',
                            maxHeight: '92vh',
                            overflow: 'auto',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}
                    >
                        {/* Header */}
                        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', background: 'linear-gradient(to right, #f8fafc, #f1f5f9)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#0f172a', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <i className="bi bi-cash-coin" style={{ color: '#16a34a' }}></i> Cobro / Abono de Fiados
                                </h2>
                                <p style={{ color: '#64748b', fontSize: '13px', margin: '4px 0 0 0' }}>
                                    Cliente: <strong>{debtCustomer.first_name} {debtCustomer.last_name}</strong> (CI: {debtCustomer.cedula || debtCustomer.dni || '9999999999999'})
                                </p>
                            </div>
                            <button
                                onClick={() => setShowCobrarModal(false)}
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Contenido */}
                        <div style={{ padding: '24px' }}>
                            {loadingDebts ? (
                                <div style={{ textAlign: 'center', padding: '30px 0' }}>
                                    <div style={{
                                        display: 'inline-block',
                                        width: '36px',
                                        height: '36px',
                                        border: '3px solid #e2e8f0',
                                        borderTopColor: '#16a34a',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    <p style={{ marginTop: '12px', color: '#64748b', fontSize: '14px' }}>Consultando pedidos fiados pendientes...</p>
                                </div>
                            ) : (
                                <>
                                    {/* Resumen Deuda Total */}
                                    <div style={{
                                        background: (customerDebts?.total_debt || 0) > 0 ? '#fef2f2' : '#f0fdf4',
                                        border: `1px solid ${(customerDebts?.total_debt || 0) > 0 ? '#fecaca' : '#bbf7d0'}`,
                                        borderRadius: '12px',
                                        padding: '16px 20px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '20px'
                                    }}>
                                        <div>
                                            <span style={{ fontSize: '12px', fontWeight: '700', color: (customerDebts?.total_debt || 0) > 0 ? '#991b1b' : '#166534', textTransform: 'uppercase' }}>
                                                SALDO TOTAL PENDIENTE POR COBRAR
                                            </span>
                                            <div style={{ fontSize: '13px', color: '#475569', marginTop: '2px' }}>
                                                {customerDebts?.orders_count || 0} orden{(customerDebts?.orders_count || 0) !== 1 ? 'es' : ''} fiada{(customerDebts?.orders_count || 0) !== 1 ? 's' : ''} sin pagar
                                            </div>
                                        </div>
                                        <div style={{ fontSize: '28px', fontWeight: '900', color: (customerDebts?.total_debt || 0) > 0 ? '#dc2626' : '#16a34a' }}>
                                            ${(customerDebts?.total_debt || 0).toFixed(2)} <span style={{ fontSize: '14px', fontWeight: '700' }}>USD</span>
                                        </div>
                                    </div>

                                    {/* Listado de Pedidos Fiados */}
                                    {customerDebts?.orders && customerDebts.orders.length > 0 ? (
                                        <div style={{ marginBottom: '20px' }}>
                                            <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b', marginBottom: '8px' }}>
                                                Órdenes con saldo pendiente:
                                            </h4>
                                            <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                                    <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                                        <tr>
                                                            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Orden</th>
                                                            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Fecha</th>
                                                            <th style={{ padding: '8px 12px', textAlign: 'left' }}>Detalle</th>
                                                            <th style={{ padding: '8px 12px', textAlign: 'right' }}>Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {customerDebts.orders.map((o) => (
                                                            <tr key={o.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                                                <td style={{ padding: '8px 12px', fontWeight: '700', color: '#0f172a' }}>
                                                                    #{o.order_number}
                                                                </td>
                                                                <td style={{ padding: '8px 12px', color: '#64748b' }}>
                                                                    {new Date(o.created_at).toLocaleDateString('es-EC', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                                                                </td>
                                                                <td style={{ padding: '8px 12px', color: '#334155' }}>
                                                                    {o.school_name ? `Escuela: ${o.school_name} (${o.lunchbox_count} loncheras)` : (o.items?.map(it => `${it.quantity}x ${it.product_name}`).join(', ') || 'Consumo')}
                                                                </td>
                                                                <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '700', color: '#dc2626' }}>
                                                                    ${(o.pending_amount ?? o.total).toFixed(2)}
                                                                    {o.pending_amount != null && o.pending_amount < o.total - 0.009 && (
                                                                        <div style={{ fontSize: '11px', fontWeight: '500', color: '#64748b' }}>
                                                                            de ${o.total.toFixed(2)}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ padding: '16px', background: '#f8fafc', borderRadius: '8px', textAlign: 'center', color: '#64748b', fontSize: '13px', marginBottom: '20px' }}>
                                            Este cliente no registra órdenes con saldo pendiente.
                                        </div>
                                    )}

                                    {/* Formulario de Cobro / Abono */}
                                    <form onSubmit={handleSubmitCobro}>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                            <div>
                                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                                                    Monto a Cobrar / Abonar ($ USD) *
                                                </label>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        required
                                                        value={cobrarAmount}
                                                        onChange={(e) => setCobrarAmount(e.target.value)}
                                                        placeholder="0.00"
                                                        style={{
                                                            width: '100%',
                                                            padding: '10px 12px',
                                                            borderRadius: '8px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '15px',
                                                            fontWeight: '700'
                                                        }}
                                                    />
                                                    {customerDebts?.total_debt > 0 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setCobrarAmount(customerDebts.total_debt.toFixed(2))}
                                                            title={`Cobrar toda la deuda ($${customerDebts.total_debt.toFixed(2)})`}
                                                            style={{
                                                                padding: '8px 12px',
                                                                backgroundColor: '#f1f5f9',
                                                                border: '1px solid #cbd5e1',
                                                                borderRadius: '8px',
                                                                fontSize: '11px',
                                                                fontWeight: '700',
                                                                cursor: 'pointer',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            Pagar Todo
                                                        </button>
                                                    )}
                                                </div>
                                                {parseFloat(cobrarAmount) > 0 && customerDebts?.total_debt > 0 && (() => {
                                                    const amount = Math.round(parseFloat(cobrarAmount) * 100) / 100;
                                                    const remaining = customerDebts.total_debt - amount;
                                                    if (remaining < -0.009) {
                                                        return <div style={{ marginTop: '6px', fontSize: '12px', fontWeight: '700', color: '#dc2626' }}>Es mayor a lo que debe (${customerDebts.total_debt.toFixed(2)})</div>;
                                                    }
                                                    return (
                                                        <div style={{ marginTop: '6px', fontSize: '12px', fontWeight: '700', color: remaining > 0.009 ? '#b45309' : '#15803d' }}>
                                                            {remaining > 0.009 ? `Abono · quedará debiendo $${remaining.toFixed(2)}` : 'Pago total · la deuda queda en $0.00'}
                                                        </div>
                                                    );
                                                })()}
                                            </div>

                                            <div>
                                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>
                                                    Método de Pago Recibido *
                                                </label>
                                                <select
                                                    value={cobrarMethod}
                                                    onChange={(e) => setCobrarMethod(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px 12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #d1d5db',
                                                        fontSize: '14px',
                                                        background: 'white'
                                                    }}
                                                >
                                                    <option value="efectivo">Efectivo</option>
                                                    <option value="transferencia">Transferencia / Banco / DeUna</option>
                                                    <option value="tarjeta">Tarjeta Débito / Crédito</option>
                                                </select>
                                            </div>
                                        </div>

                                        {cobrarMethod === 'transferencia' && (
                                            <div style={{ marginBottom: '16px' }}>
                                                <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                                    Número de Referencia / Comprobante
                                                </label>
                                                <input
                                                    type="text"
                                                    value={cobrarReference}
                                                    onChange={(e) => setCobrarReference(e.target.value)}
                                                    placeholder="Ej: 987654321"
                                                    style={{
                                                        width: '100%',
                                                        padding: '9px 12px',
                                                        borderRadius: '8px',
                                                        border: '1px solid #d1d5db',
                                                        fontSize: '14px'
                                                    }}
                                                />
                                            </div>
                                        )}

                                        <div style={{ marginBottom: '20px' }}>
                                            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                                Notas del Abono / Cobro (Opcional)
                                            </label>
                                            <input
                                                type="text"
                                                value={cobrarNotes}
                                                onChange={(e) => setCobrarNotes(e.target.value)}
                                                placeholder="Ej: Pago de almuerzos de la semana..."
                                                style={{
                                                    width: '100%',
                                                    padding: '9px 12px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #d1d5db',
                                                    fontSize: '14px'
                                                }}
                                            />
                                        </div>

                                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                            <button
                                                type="button"
                                                onClick={() => setShowCobrarModal(false)}
                                                style={{
                                                    padding: '10px 18px',
                                                    backgroundColor: '#f1f5f9',
                                                    border: '1px solid #cbd5e1',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    color: '#475569',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                type="submit"
                                                disabled={processingCobro}
                                                style={{
                                                    padding: '10px 24px',
                                                    backgroundColor: '#16a34a',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    fontSize: '14px',
                                                    fontWeight: '700',
                                                    cursor: processingCobro ? 'not-allowed' : 'pointer',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.3)'
                                                }}
                                            >
                                                <i className="bi bi-check2-circle" style={{ fontSize: '18px' }}></i>
                                                {processingCobro ? 'Registrando Cobro...' : 'Confirmar Cobro / Abono'}
                                            </button>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ==================================================================== */}
            {/* MODAL DE EDICIÓN DE CLIENTE */}
            {/* ==================================================================== */}
            {showEditModal && editingCustomer && (
                <div
                    onClick={() => setShowEditModal(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1100,
                        padding: '16px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '560px',
                            width: '100%',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}
                    >
                        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#0f172a', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="bi bi-pencil-square" style={{ color: 'var(--primary-color)' }}></i> Editar Cliente
                            </h2>
                            <button
                                onClick={() => setShowEditModal(false)}
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' }}
                            >
                                ×
                            </button>
                        </div>

                        <form onSubmit={handleUpdateCustomer}>
                            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={editingCustomer.first_name}
                                            onChange={(e) => setEditingCustomer({ ...editingCustomer, first_name: e.target.value })}
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Apellido *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={editingCustomer.last_name}
                                            onChange={(e) => setEditingCustomer({ ...editingCustomer, last_name: e.target.value })}
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Cédula / RUC
                                        </label>
                                        <input
                                            type="text"
                                            value={editingCustomer.cedula}
                                            onChange={(e) => setEditingCustomer({ ...editingCustomer, cedula: e.target.value })}
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Teléfono
                                        </label>
                                        <input
                                            type="text"
                                            value={editingCustomer.phone}
                                            onChange={(e) => setEditingCustomer({ ...editingCustomer, phone: e.target.value })}
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                        Correo Electrónico
                                    </label>
                                    <input
                                        type="email"
                                        value={editingCustomer.email}
                                        onChange={(e) => setEditingCustomer({ ...editingCustomer, email: e.target.value })}
                                        style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                    />
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                        Dirección
                                    </label>
                                    <input
                                        type="text"
                                        value={editingCustomer.address}
                                        onChange={(e) => setEditingCustomer({ ...editingCustomer, address: e.target.value })}
                                        placeholder="Ej: Calle Principal y Sucre, Tulcán"
                                        style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                    />
                                </div>
                            </div>

                            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '12px', justifyContent: 'flex-end', background: '#f8fafc' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowEditModal(false)}
                                    style={{ padding: '9px 16px', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={submitting}
                                    style={{ padding: '9px 20px', backgroundColor: 'var(--primary-color, #4a1f0c)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: submitting ? 'not-allowed' : 'pointer' }}
                                >
                                    {submitting ? 'Guardando...' : 'Guardar Cambios'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================================== */}
            {/* MODAL DE CREACIÓN DE NUEVO CLIENTE */}
            {/* ==================================================================== */}
            {showModal && (
                <div
                    onClick={closeModal}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1100,
                        padding: '16px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '560px',
                            width: '100%',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}
                    >
                        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#0f172a', margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="bi bi-person-plus-fill" style={{ color: 'var(--primary-color)' }}></i> Registrar Nuevo Cliente
                            </h2>
                            <button
                                onClick={closeModal}
                                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' }}
                            >
                                ×
                            </button>
                        </div>

                        <form onSubmit={handleCreateCustomer}>
                            <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={newCustomer.first_name}
                                            onChange={(e) => setNewCustomer({ ...newCustomer, first_name: e.target.value })}
                                            placeholder="Nombre"
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Apellido *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={newCustomer.last_name}
                                            onChange={(e) => setNewCustomer({ ...newCustomer, last_name: e.target.value })}
                                            placeholder="Apellido"
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Cédula / RUC (Opcional)
                                        </label>
                                        <input
                                            type="text"
                                            value={newCustomer.cedula}
                                            onChange={(e) => setNewCustomer({ ...newCustomer, cedula: e.target.value })}
                                            placeholder="040..."
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                            Teléfono / WhatsApp *
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            value={newCustomer.phone}
                                            onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
                                            placeholder="099..."
                                            style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                        Correo Electrónico *
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={newCustomer.email}
                                        onChange={(e) => setNewCustomer({ ...newCustomer, email: e.target.value })}
                                        placeholder="cliente@ejemplo.com"
                                        style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                    />
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#334155', marginBottom: '6px' }}>
                                        Dirección
                                    </label>
                                    <input
                                        type="text"
                                        value={newCustomer.address}
                                        onChange={(e) => setNewCustomer({ ...newCustomer, address: e.target.value })}
                                        placeholder="Dirección en Tulcán..."
                                        style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' }}
                                    />
                                </div>
                            </div>

                            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '12px', justifyContent: 'flex-end', background: '#f8fafc' }}>
                                <button
                                    type="button"
                                    onClick={closeModal}
                                    style={{ padding: '9px 16px', backgroundColor: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={submitting}
                                    style={{ padding: '9px 20px', backgroundColor: 'var(--primary-color, #4a1f0c)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: submitting ? 'not-allowed' : 'pointer' }}
                                >
                                    {submitting ? 'Registrando...' : 'Registrar Cliente'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ==================================================================== */}
            {/* MODAL DE VISTA PREVIA DEL VOUCHER SRI */}
            {/* ==================================================================== */}
            {previewCustomer && (
                <div
                    onClick={() => setPreviewCustomer(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1100,
                        padding: '16px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            maxWidth: '420px',
                            width: '100%',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            padding: '20px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '1px solid #e5e7eb', paddingBottom: '10px' }}>
                            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#1f2937' }}>
                                <i className="bi bi-receipt"></i> Voucher / Ticket SRI
                            </h3>
                            <button
                                onClick={() => setPreviewCustomer(null)}
                                style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#6b7280' }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Ticket Renderizado */}
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '16px',
                            border: '1px solid #e2e8f0',
                            borderRadius: '4px',
                            fontFamily: '"Courier New", Courier, monospace',
                            fontSize: '11px',
                            color: '#000',
                            lineHeight: 1.3
                        }}>
                            <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '8px', marginBottom: '8px' }}>
                                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{voucherConfig.business_name}</div>
                                <div>RUC: {voucherConfig.ruc}</div>
                                <div>{voucherConfig.establishment_address}</div>
                                <div style={{ marginTop: '2px', fontSize: '9px' }}>Obligado a llevar contabilidad: {voucherConfig.obligation_contable}</div>
                                {voucherConfig.contribuyente_regimen && <div style={{ fontSize: '9px' }}>CONTRIBUYENTE {voucherConfig.contribuyente_regimen}</div>}
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '11px' }}>FACTURA ELECTRÓNICA</div>
                                <div>No: 001-001-000000129</div>
                                <div>Fecha: {new Date().toLocaleDateString('es-EC')} {new Date().toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' })}</div>
                                <div>Estado: <span style={{ fontWeight: 'bold' }}>AUTORIZADO</span></div>
                                <div style={{ marginTop: '4px' }}><strong>Cliente:</strong> {previewCustomer.first_name} {previewCustomer.last_name}</div>
                                <div><strong>RUC/CI:</strong> {previewCustomer.cedula || previewCustomer.dni || previewCustomer.identification || '9999999999999'}</div>
                                {previewCustomer.address && <div><strong>Dir:</strong> {previewCustomer.address}</div>}
                                {previewCustomer.email && <div><strong>Email:</strong> {previewCustomer.email}</div>}
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', fontWeight: 'bold', borderBottom: '1px solid #000', paddingBottom: '2px', marginBottom: '3px' }}>
                                    <span>Cant. Descripción</span>
                                    <span style={{ textAlign: 'right' }}>P.Unit</span>
                                    <span style={{ textAlign: 'right' }}>Total</span>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', margin: '2px 0' }}>
                                    <span>1x Consumo General</span>
                                    <span style={{ textAlign: 'right' }}>$8.70</span>
                                    <span style={{ textAlign: 'right' }}>$8.70</span>
                                </div>
                            </div>

                            <div style={{ borderBottom: '1px dashed #000', paddingBottom: '6px', marginBottom: '6px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>SUBTOTAL:</span>
                                    <span>$8.70</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>IVA:</span>
                                    <span>$1.30</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: 'bold', marginTop: '3px', borderTop: '1px solid #000', paddingTop: '3px' }}>
                                    <span>TOTAL A PAGAR:</span>
                                    <span>$10.00</span>
                                </div>
                            </div>

                            <div style={{ textAlign: 'center', borderBottom: '1px dashed #000', paddingBottom: '8px', marginBottom: '8px' }}>
                                <div style={{ fontSize: '9px', fontWeight: 'bold', marginBottom: '2px' }}>CLAVE DE ACCESO / AUTORIZACIÓN:</div>
                                <div style={{ fontSize: '8.5px', wordBreak: 'break-all' }}>
                                    2408202601040178861700110010010000001291234567818
                                </div>
                            </div>

                            <div style={{ textAlign: 'center', fontSize: '9px', whiteSpace: 'pre-line', marginBottom: '6px' }}>
                                {voucherConfig.footer_message}
                            </div>
                        </div>

                        <div style={{ marginTop: '16px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                                type="button"
                                onClick={async () => {
                                    try {
                                        const dateStr = new Date().toLocaleDateString('es-EC');
                                        const timeStr = new Date().toLocaleTimeString('es-EC', { hour: '2-digit', minute: '2-digit' });
                                        const dni = previewCustomer.cedula || previewCustomer.dni || '9999999999999';
                                        
                                        const ticketContent = 
`================================
${voucherConfig.business_name}
RUC: ${voucherConfig.ruc}
${voucherConfig.establishment_address}
Obligado a contabilidad: ${voucherConfig.obligation_contable}
CONTRIBUYENTE ${voucherConfig.contribuyente_regimen}
================================
FACTURA ELECTRONICA
No: 001-001-000000129
Fecha: ${dateStr} ${timeStr}
Estado: AUTORIZADO
--------------------------------
Cliente: ${previewCustomer.first_name} ${previewCustomer.last_name}
RUC/CI: ${dni}
${previewCustomer.address ? `Dir: ${previewCustomer.address}\n` : ''}${previewCustomer.email ? `Email: ${previewCustomer.email}\n` : ''}--------------------------------
Cant. Descripcion        Total
1x Consumo General      $8.70
--------------------------------
SUBTOTAL:               $8.70
IVA:                    $1.30
--------------------------------
TOTAL A PAGAR:         $10.00
--------------------------------
Forma de Pago:
EFECTIVO (SIN SISTEMA FINANCIERO): $10.00
================================
CLAVE DE ACCESO:
2408202601040178861700110010010000001291234567818
================================
${voucherConfig.footer_message}
`;
                                        await printerService.printCustomTicket(ticketContent, 'receipt');
                                        alert('Voucher enviado a la impresora.');
                                    } catch (err) {
                                        window.print();
                                    }
                                }}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: 'var(--primary-color, #4a1f0c)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                            >
                                <i className="bi bi-printer-fill"></i> Imprimir Voucher POS
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Clientes;
